import { FileIcon, defaultStyles } from 'react-file-icon';

const SUPPORTED_EXTENSIONS = [
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
  'txt', 'csv', 'zip', 'rar', '7z', 'tar',
  'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg',
  'html', 'css', 'js', 'json', 'xml',
  'mp3', 'mp4', 'avi', 'mov',
  'odt', 'rtf',
];

const MIME_RULES = [
  [/wordprocessingml|msword|application\/msword/, 'docx'],
  [/spreadsheetml|ms-?excel/, 'xlsx'],
  [/presentationml|ms-?powerpoint/, 'pptx'],
  [/^application\/pdf$|\/pdf$/, 'pdf'],
  [/text\/csv|application\/csv/, 'csv'],
  [/application\/(zip|x-zip-compressed|x-rar|x-7z)/, 'zip'],
  [/^image\/(png|jpe?g|gif|webp|svg)/, (m) => (m[1] === 'svg' ? 'svg' : m[1].replace('jpeg', 'jpg'))],
  [/^text\/plain$/, 'txt'],
  [/^text\/html$/, 'html'],
  [/^application\/json$/, 'json'],
];

function resolveFileExtension(file) {
  const raw = (file?.extension || '').toLowerCase().trim().replace(/^\./, '');

  if (SUPPORTED_EXTENSIONS.includes(raw)) return raw;

  for (const [pattern, target] of MIME_RULES) {
    const m = raw.match(pattern);
    if (m) return typeof target === 'function' ? target(m) : target;
  }

  const filename = file?.name || '';
  const fromName = filename.split('.').pop()?.toLowerCase();
  if (fromName && SUPPORTED_EXTENSIONS.includes(fromName)) return fromName;

  return fromName?.slice(0, 4) || 'file';
}

export function FileTypeIcon({ file, className, style }) {
  const ext = resolveFileExtension(file);
  const props = defaultStyles[ext] || {};
  return (
    <div className={className} style={style}>
      <FileIcon extension={ext} {...props} />
    </div>
  );
}
